import {
  TOURNAMENT_STATUS_COMPLETED,
  TOURNAMENT_STATUS_IN_PROGRESS,
  TOURNAMENT_STATUS_UPCOMING
} from './constants';

export const ERROR_INVALID_SESSION = 'Your session has expired!';
export const ERROR_LOGIN_FAILED = 'Login failed. Please try again.';
export const VALIDATION_ERROR_INVALID_EMAIL =
  'Please enter a valid email address.';
export const VALIDATION_ERROR_INVALID_PASSWORD =
  'Please enter a valid password.';

export const TOURNAMENT_STATUSES = {
  [TOURNAMENT_STATUS_IN_PROGRESS]: 'In Progress',
  [TOURNAMENT_STATUS_UPCOMING]: 'Upcoming',
  [TOURNAMENT_STATUS_COMPLETED]: 'Completed'
};

export const TOURNAMENT_LIST_BUTTONS = {
  [TOURNAMENT_STATUS_IN_PROGRESS]: 'Play Now',
  [TOURNAMENT_STATUS_UPCOMING]: 'Remind Me',
  [TOURNAMENT_STATUS_COMPLETED]: 'Completed'
};



// WEBPACK FOOTER //
// ./src/utils/messages.js